import { LETTERWIDTH, STRIPHEIGHT } from '@components/UI-Components/StandardTableView'
import { useObserver } from 'mobx-react-lite'
import React from 'react'
import styled from 'styled-components'
import { TableViewStoreContext } from '../StandardTableView'
import { JumpToStrip } from './JumpToStrip'

export interface ILetterJumpToProps {
  data: Array<string>
  stripWidth?: number
  isNewLayout?: boolean
}

const StyledContainer = styled.div<{ width: number }>`
  height: ${props => props.width + 'px'};
  padding: 20px 0px 15px 0px;
`

export const LetterJumpTo: React.FunctionComponent<ILetterJumpToProps> = ({
  data,
  stripWidth
}) => {
  return useObserver(function useHook() {
    const { onLetterSelect, letterToHighlight } = React.useContext(
      TableViewStoreContext
    ) as any

    return (
      <StyledContainer width={stripWidth as number}>
        <JumpToStrip
          dataWidth={LETTERWIDTH}
          stripData={data}
          dataToHighlight={letterToHighlight}
          onDataSelect={onLetterSelect}
          height={STRIPHEIGHT}
        />
      </StyledContainer>
    )
  })
}
